export const APTITUDE_SKILLS = "/api/aptitude-skills"
export const APTITUDE_SKILL = "/api/aptitude-skills/:param"
export const APTITUDE_SKILL_ACTIVATE = "/api/aptitude-skills/:param/activate"
export const EXPORT_APTITUDE_SKILL = "/api/aptitude-skills/export"
export const IMPORT_APTITUDE_SKILL = "/api/aptitude-skills/import"
